<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { usePageLoadingStore } from "../../../../stores/pageLoading";
import curriculumService from "../../../admin/services/curriculum/curriculumService";
import { useAlertStore } from "../../../../stores/alertStore";
import SiteCurriculumDetailModal from "../../../admin/components/modal/site/SiteCurriculumDetailModal.vue";
const { $alert, $confirm } = useAlertStore();
const loadingStore = usePageLoadingStore();
const { $toast } = getCurrentInstance().appContext.config.globalProperties;

const currentURL = window.location.host;
const yearsArr = ref([1,2,3,4,5,6,7,8,9,10,11,12]);

onMounted(() => {
    retrieveUserCurriculum();
});

const summaryDetail = ref({
    summaryName: '',
    summaryOpenYn: '',
});
const curriculumList = ref([]);
const curriculumModal = ref(null);

const deleteYn = ref(true);

const retrieveUserCurriculum = () => {
    loadingStore.loading = true;
    curriculumService.retrieveUserCurriculum()
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                summaryDetail.value = result.summary;
                curriculumList.value = (result.curriculumList || []).slice().sort((a, b) => {
                    const ao = Number(a.curriculumOrder) || 0;
                    const bo = Number(b.curriculumOrder) || 0;
                    if (ao !== bo) return ao - bo;
                    const an = (a.curriculumName || '').toString();
                    const bn = (b.curriculumName || '').toString();
                    return an.localeCompare(bn);
                });
            }
        }).catch((res) => {
            loadingStore.loading = false;
            // $toast("error", res);
        });
};

const handleClickRow = async (item) => {
    const result = await curriculumService.retrieveUserCurriculumDetail(item.curriculumId);
    curriculumModal.value.init(result.data.result);
    curriculumModal.value.show();
};
</script>
<template>
    <div class="container">
        <div class="inner">
            <div class="title page-title">
                <h3>총괄표</h3>
            </div>
            <div class="list-top" style="height: auto;">
                <h3>{{ summaryDetail.summaryName }}</h3>
                <div>
                    <KSASecondaryButton class="gray_button ml-xs" style="width: 150px;" text="총괄표 다운로드" @click="$download(summaryDetail.summaryImageDir)" :disabled="!summaryDetail.summaryImageDir"/>
                </div>
            </div>
            <!-- s: 기초 과정 -->
            <div class="mt-xs">
                <div class="table-form curriculum-table">
                    <table class="horizontal">
                        <colgroup>
                            <col width="50px">
                            <col width="110px">
                            <col />
                            <col width="100px">
                            <col width="80px">
                            <col width="80px">
                            <col width="140px">
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                        </colgroup>
                        <thead>
                            <tr>
                                <th rowspan="2">수준</th>
                                <th rowspan="2">분야</th>
                                <th rowspan="2">과정명</th>
                                <th rowspan="2">방식</th>
                                <th colspan="2">교육일수</th>
                                <th rowspan="2">대상</th>
                                <th colspan="12">연간교육일정(월)</th>
                            </tr>
                            <tr>
                                <th>기간(일)</th>
                                <th>시간</th>
                                <th class="month">1</th>
                                <th class="month">2</th>
                                <th class="month">3</th>
                                <th class="month">4</th>
                                <th class="month">5</th>
                                <th class="month">6</th>
                                <th class="month">7</th>
                                <th class="month">8</th>
                                <th class="month">9</th>
                                <th class="month">10</th>
                                <th class="month">11</th>
                                <th class="month">12</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in curriculumList.filter((el) => el.curriculumGb === '01')" :key="item.curriculumId">
                                <td v-if="index === 0" :rowspan="curriculumList.filter((el) => el.curriculumGb === '01').length">기초</td>
                                <td @click="handleClickRow(item)">{{ item.curriculumFiled }}</td>
                                <td @click="handleClickRow(item)" class="text-left">
                                  <span v-if="item.curriculumLabel" class="label" :class="{'blue_line': item.curriculumLabel === '채용연계', 'blue': item.curriculumLabel === '취업중점'}">{{ item.curriculumLabel }}</span>
                                  {{ item.curriculumName }}
                                </td>
                                <td @click="handleClickRow(item)">{{ item.curriculumMth }}</td>
                                <td @click="handleClickRow(item)">{{ item.curriculumDays }}</td>
                                <td @click="handleClickRow(item)">{{ item.curriculumHours }}</td>
                                <td @click="handleClickRow(item)">{{ item.curriculumTrgt }}</td>
                                <td v-for="(month) in yearsArr" :key="month" @click="handleClickRow(item)">{{ item.annualSchedule.split(',').includes(month.toString()) ? 'O' : '' }}</td>
                            </tr>
                            <tr v-if="curriculumList.filter((el) => el.curriculumGb === '01').length === 0">
                                <td colspan="19">등록된 기초 과정 정보가 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- e: 기초 과정 -->
            <!-- s: 심화 과정 -->
            <div class="mt-xs">
                <div class="table-form curriculum-table">
                    <table class="horizontal">
                        <colgroup>
                            <col width="50px">
                            <col width="110px">
                            <col />
                            <col width="100px">
                            <col width="80px">
                            <col width="80px">
                            <col width="140px">
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                            <col width="30px"/>
                        </colgroup>
                        <thead>
                            <tr>
                                <th rowspan="2">수준</th>
                                <th rowspan="2">분야</th>
                                <th rowspan="2">과정명</th>
                                <th rowspan="2">방식</th>
                                <th colspan="2">교육일수</th>
                                <th rowspan="2">대상</th>
                                <th colspan="12">연간교육일정(월)</th>
                            </tr>
                            <tr>
                                <th>기간(일)</th>
                                <th>시간</th>
                                <th class="month">1</th>
                                <th class="month">2</th>
                                <th class="month">3</th>
                                <th class="month">4</th>
                                <th class="month">5</th>
                                <th class="month">6</th>
                                <th class="month">7</th>
                                <th class="month">8</th>
                                <th class="month">9</th>
                                <th class="month">10</th>
                                <th class="month">11</th>
                                <th class="month">12</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in curriculumList.filter((el) => el.curriculumGb === '02')" :key="item.curriculumId">
                                <td v-if="index === 0" :rowspan="curriculumList.filter((el) => el.curriculumGb === '02').length">심화</td>
                                <td @click="handleClickRow(item)">{{ item.curriculumFiled }}</td>
                                <td @click="handleClickRow(item)" class="text-left">
                                  <span v-if="item.curriculumLabel" class="label" :class="{'blue_line': item.curriculumLabel === '채용연계', 'blue': item.curriculumLabel === '취업중점'}">{{ item.curriculumLabel }}</span>
                                  {{ item.curriculumName }}
                                </td>
                                <td @click="handleClickRow(item)">{{ item.curriculumMth }}</td>
                                <td @click="handleClickRow(item)">{{ item.curriculumDays }}</td>
                                <td @click="handleClickRow(item)">{{ item.curriculumHours }}</td>
                                <td @click="handleClickRow(item)">{{ item.curriculumTrgt }}</td>
                                <td v-for="(month) in yearsArr" :key="month" @click="handleClickRow(item)">{{ item.annualSchedule.split(',').includes(month.toString()) ? 'O' : '' }}</td>
                            </tr>
                            <tr v-if="curriculumList.filter((el) => el.curriculumGb === '02').length === 0">
                                <td colspan="19">등록된 심화 과정 정보가 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- e: 심화 과정 -->
            <!-- <img width="100%" src="/src/assets/images/lecture_curriculum.jpg" alt="교육 프로그램 총괄표" /> -->
            <div class="title page-title">
                <h3>선발 절차 / 교육 특전</h3>
            </div>
            <div class="process-wrap">
                <div class="left-area">
                    <div class="title-box">
                        <b>온라인 교육</b>
                        <small>(온라인 교육의 경우, 별도의 선발과정 없이 신청 완료하신 분에 한해 수강 가능합니다.)</small>
                    </div>
                    <ul>
                        <li>
                            <img src="/src/assets/images/lecture-step1.png" alt="모집공고" />
                            <span>모집공고</span>
                        </li>
                        <li>
                            <img src="/src/assets/images/lecture-step2.png" alt="접수" />
                            <span>접수</span>
                        </li>
                        <li>
                            <img src="/src/assets/images/lecture-step3.png" alt="신청완료" />
                            <span>신청완료</span>
                        </li>
                    </ul>
                    <div class="title-box">
                        <b>오프라인 교육</b>
                        <small>(재직자 교육 및 학점인정교육의 경우 선발 절차가 다를 수 있습니다.)</small>
                    </div>
                    <ul>
                        <li>
                            <img src="/src/assets/images/lecture-step1.png" alt="모집공고" />
                            <span>모집공고</span>
                        </li>
                        <li>
                            <img src="/src/assets/images/lecture-step2.png" alt="서류 (1차)" />
                          <span>서류 (1차)</span>
                        </li>
                        <li>
                            <img src="/src/assets/images/lecture-step3_offline.png" alt="면접 (2차)" />
                          <span>면접 (2차)</span>
                        </li>
                        <li>
                            <img src="/src/assets/images/lecture-step4.png" alt="최종 선발" />
                          <span>최종 선발</span>
                        </li>
                    </ul>
                </div>
                <div class="right-area">
                    <div class="title-box blue">
                        <b>아카데미 특전</b>
                    </div>
                    <div class="text-box">
                        <p><i>1.</i>모든 강의를 <b>전액 무료로 제공</b>합니다.</p>
                    </div>
                    <div class="text-box">
                        <p><i>2.</i>교육과정 및 취업 역량 강화를 위한 <b>컨설팅을 제공</b>합니다.</p>
                    </div>
                    <div class="text-box">
                        <p><i>3.</i>기업체 초빙 <b>직무특강 및 채용설명회를 개최</b>합니다.</p>
                    </div>
                    <div class="text-box">
                        <p><i>4.</i>심화 과정은 Team-Project를 포함한 <b>실습 중심의 교육</b>으로 진행됩니다.</p>
                    </div>
                </div>
            </div>
        </div>
        <SiteCurriculumDetailModal ref="curriculumModal" />
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    hr {
        background-color: $gray-regular_color;
        height: 1px;
        border: 0;
        line-height: inherit;
        margin: 20px 0 0;
    }

    .process-wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        & > div {
            &.left-area {
                width: 828px;
                border-right: $border_line;
                padding-right: 73px;
            }
            &.right-area {
                width: 614px;
                padding-left: 73px;
                .title-box {
                    margin-bottom: 10px;
                }
            }
        }
        .title-box {
            background-color: $gray-light_color;
            @include font-size_lg;
            padding: 10px 20px;
            margin-bottom: 20px;
            &.blue {
                background-color: $blue_color;
                color: $gray-thin_color;
            }
            small {
                @include font-size_sm;
                margin-left: 4px;
            }
        }
        .text-box {
            position: relative;
            height: 97px;
            @include font-size_md;
            background-color: $gray-light_color;
            margin-top: 6px;
            p {
                position: absolute;
                top: 50%;
                left: 40px;
                transform: translateY(-50%);
                i {
                    position: absolute;
                    font-style: normal;
                    left: -20px;
                }
            }
        }
        ul {
            display: flex;
            align-items: center;
            padding: 0 20px 80px;
            &:last-child {
                padding-bottom: 0;
            }
            li {
                position: relative;
                @include font-size_md;
                text-align: center;
                margin-right: 84px;
                img {
                    display: block;
                    margin-bottom: 10px;
                }
                &:last-child {
                    color: $blue_color;
                    font-weight: 700;
                    &:after {
                        display: none;
                    }
                }
                &:after {
                    content: "";
                    position: absolute;
                    top: 40px;
                    right: -66px;
                    width: 48px;
                    height: 26px;
                    background: url(/src/assets/images/lecture-step_arrow.png) no-repeat center;
                }
            }
        }
    }
</style>